/**
 * En-tête éditoriale d'un écran produit : contexte discret, titre en serif (la
 * seule seconde voix de l'interface), chapô. Les écrans de contrôle (admin,
 * leads) n'en portent pas — ils ouvrent sur une ligne méta, conformément à la
 * charte.
 */
export function PageHeader({
  eyebrow,
  title,
  lede,
  action,
}: {
  eyebrow?: string;
  title: string;
  lede?: string;
  action?: React.ReactNode;
}) {
  return (
    <header className="mb-9 flex flex-wrap items-end justify-between gap-5">
      <div className="max-w-[680px]">
        {eyebrow && (
          <span className="text-[13px] text-muted-foreground">{eyebrow}</span>
        )}
        <h1 className="mt-2 mb-2.5 font-serif text-[clamp(28px,3vw,34px)] leading-[1.1] font-normal tracking-[-0.02em]">
          {title}
        </h1>
        {lede && <p className="m-0 text-[15px] leading-[1.6] text-muted-foreground">{lede}</p>}
      </div>
      {action}
    </header>
  );
}
